import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import * as color from '@constant/color';
import * as size from '@constant/size';
import TextBlock from '@component/common/block/text-block';
import TextButton from '@design-system/text-button';
import Gap from '@component/common/gap';
import { useTypedDispatch } from '@hook/common/useStore';
import { actions as modalActions } from '@store/slice/modal-slice';
import { IYAGIGO_PATH } from '@constant/iyagigo/route-path';
import { MEDIUM_MODAL_WIDTH } from '@constant/size';
import { ETheme } from '@datatype/type';

const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  width: ${MEDIUM_MODAL_WIDTH};
`;

const SubscriptionStartModal: React.FC = () => {
  const dispatch = useTypedDispatch();
  const navigate = useNavigate();

  const handleStartClick = () => {
    dispatch(modalActions.hideModal());
    navigate(IYAGIGO_PATH.CLOZE_HOME_PATH);
  };

  return (
    <Wrapper>
      <TextBlock
        text={'이야기고 Plus⁺ 시작 !'}
        design={{
          text: { size: 'large', color: color.BLACK_2, bold: true },
        }}
      />
      {/*<Gap height={'5px'} />*/}
      <TextBlock
        text={'이제 마음껏 학습할 수 있어요'}
        design={{
          text: { size: 'medium', color: color.BLACK_2, bold: false },
        }}
      />
      <Gap height={'5px'} />
      <TextBlock
        text={'구독해 주셔서 감사해요'}
        design={{
          text: { size: 'medium', color: color.GRAY_1, bold: false },
        }}
      />
      <Gap height={size.MARGIN_2} />
      <TextButton
        theme={ETheme.BROWN}
        kind={'filled'}
        size={'medium'}
        shape='pill'
        width={'100%'}
        text={'학습 시작하기'}
        handleClick={handleStartClick}
      />
    </Wrapper>
  );
};

export default SubscriptionStartModal;
